export const MODAL_OPEN = 'MODAL_OPEN';
export const modalOpen = (index) => {
  return {
    type: MODAL_OPEN,
    payload: {
      index,
    },
  };
};

export const MODAL_CLOSE = 'MODAL_CLOSE';
export const modalClose = () => {
  return {
    type: MODAL_CLOSE,
  };
};
